var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.923 14c-.51 0-.923.398-.923.889 0 .49.413.889.923.889h22.154c.51 0 .923-.398.923-.89 0-.49-.413-.888-.923-.888H10.923zM10 22c0-.49.413-.889.923-.889h22.154c.51 0 .923.398.923.889 0 .49-.413.889-.923.889H10.923c-.51 0-.923-.398-.923-.889z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.923 28.222c-.51 0-.923.398-.923.89 0 .49.413.888.923.888h22.154c.51 0 .923-.398.923-.889 0-.49-.413-.889-.923-.889H10.923z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA0NCA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjIiIGN5PSIyMiIgcj0iMjIiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC45MjMxIDE0QzEwLjQxMzMgMTQgMTAgMTQuMzk4IDEwIDE0Ljg4ODlDMTAgMTUuMzc5OCAxMC40MTMzIDE1Ljc3NzggMTAuOTIzMSAxNS43Nzc4SDMzLjA3NjlDMzMuNTg2NiAxNS43Nzc4IDM0IDE1LjM3OTggMzQgMTQuODg4OUMzNCAxNC4zOTggMzMuNTg2NiAxNCAzMy4wNzY5IDE0SDEwLjkyMzFaTTEwIDIyQzEwIDIxLjUwOTEgMTAuNDEzMyAyMS4xMTExIDEwLjkyMzEgMjEuMTExMUgzMy4wNzY5QzMzLjU4NjYgMjEuMTExMSAzNCAyMS41MDkxIDM0IDIyQzM0IDIyLjQ5MDkgMzMuNTg2NiAyMi44ODg5IDMzLjA3NjkgMjIuODg4OUgxMC45MjMxQzEwLjQxMzMgMjIuODg4OSAxMCAyMi40OTA5IDEwIDIyWiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTEwLjkyMzEgMjguMjIyMkMxMC40MTMzIDI4LjIyMjIgMTAgMjguNjIwMiAxMCAyOS4xMTExQzEwIDI5LjYwMiAxMC40MTMzIDMwIDEwLjkyMzEgMzBIMzMuMDc2OUMzMy41ODY2IDMwIDM0IDI5LjYwMiAzNCAyOS4xMTExQzM0IDI4LjYyMDIgMzMuNTg2NiAyOC4yMjIyIDMzLjA3NjkgMjguMjIyMkgxMC45MjMxWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";
export { SvgIconMenu as ReactComponent };